/**
 * Flatten a DRF validation body into one message per field.
 *
 * Returns `null` when the failure carries no field errors — a network fault or
 * a 500 — so the caller can tell "the server refused this field" from "the
 * request did not land", and show a toast rather than silently nothing.
 */
export function fieldErrors(error: unknown): Record<string, string> | null {
  // `fieldErrors`, not `data`: every mutation in this slice throws through
  // `unwrap` -> `toApiError`, which returns `{status, detail?, fieldErrors?,
  // code?}`. Reading `.data` matched nothing the client ever produces, so
  // every refusal the server named a field for arrived as a generic toast
  // with nothing under the field — where the Django form renders it.
  const detail = (error as { fieldErrors?: Record<string, unknown> })
    ?.fieldErrors;
  if (!detail || typeof detail !== "object") return null;

  const entries = Object.entries(detail).flatMap(([key, value]) => {
    const message = Array.isArray(value) ? value[0] : value;
    return typeof message === "string" ? [[key, message] as const] : [];
  });
  return entries.length > 0 ? Object.fromEntries(entries) : null;
}
